import Marquee from "react-fast-marquee";

const ITEMS = [
  "WEBDESIGN",
  "GOOGLE ADS",
  "WEBENTWICKLUNG",
  "SEO",
  "LANDINGPAGES",
  "BRANDING",
  "PERFORMANCE MARKETING",
];

export default function MarqueeBand() {
  return (
    <section className="border-y border-black/10 bg-ink py-6" data-testid="marquee-band">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-display text-3xl uppercase text-[#f4f1ea] md:text-4xl">{item}</span>
            <span className="text-2xl text-[#2c3bff] md:text-3xl">✳</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
